import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { __ } from '@wordpress/i18n'
import { createInterpolateElement } from '@wordpress/element'
export const FlmThankYouView = (props) => {
  const { setShowThankYou, liveMeetings } = props
  React.useEffect(() => {
    document.querySelector('#flm-ty-header').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' })
  }, [])

  return (
    <Container className={'flm-ty-page'}>
      <div className={'flm-header'} id={'flm-ty-header'}>
        <Row>
          <Col lg={4}>

          </Col>
          <Col lg={8} md={12} sm={12}>
            <h1>
              {createInterpolateElement(
                __('<bNormal>Dziękujemy</bNormal> za zapis na<br /><b>bezpłatne wydarzenie</b>', 'strefamanagera'),
                {
                  bNormal:<b className={'normal'}></b>,
                  b: <b></b>,
                  br: <br />
                }
              )}
            </h1>
            <p>
            {createInterpolateElement(
                __('<b>W ciągu 20 minut na</b> podany adres e-mail wyślemy do Ciebie dane dostępowe do wydarzenia.', 'strefamanagera'),
                {
                  b: <b></b>
                }
            )}
            </p>
          </Col>
        </Row>
      </div>
      <div className={'flm-ty-content'}>
        <ul>
          <li>
            <h1>
              {createInterpolateElement(
              __('<b>Już teraz zapraszamy Cię</b> także do naszej społeczności w social mediach.', 'strefamanagera'),
              {
                b: <b></b>
              }
              )}
            </h1>
            <p>
            {createInterpolateElement(
                __('<b>Polub nasze strony, obserwuj je</b> i ciesz się stałym kontaktem z innymi osobami na podobnych stanowiskach. To świetny sposób, aby zawsze być na bieżąco z newsami managerskimi i zbudować wartościową grupę networkingową.', 'strefamanagera'),
              {
                b: <b></b>
              }
              )}
            </p>
            <div className={'icons'}>
              <a href={'https://pl-pl.facebook.com/strefamanagerapl'}><img
                src={'/wp-content/themes/sm-theme/assets/images/free-live-meeting/facebook.png'}/></a>
              <a href={'https://www.linkedin.com/company/strefa-managera/'}><img
                src={'/wp-content/themes/sm-theme/assets/images/free-live-meeting/linkedin.png'}/></a>
            </div>
          </li>
          <li>
            <h1>
            {createInterpolateElement(
                __('<b>Chcesz zapoznać się</b> z naszą ofertą lub dowiedzieć więcej o Strefie Managera? <b>Zapraszamy!</b>'),
                {
                  b: <b></b>
                }
            )}
            </h1>

            <div className={'buttons d-flex align-items-center'}>

              <a href={'/oferta'}>
                <div className={'pinkBtn'}>
                  <div className="btn btn-lg">
                  {__('Zobacz ofertę', 'strefamanagera')}
                  </div>
                </div>
              </a>

              <a href={'/'}>
                <div className={'primaryBtn'}>
                  <div className="btn btn-lg">
                  {__('Przejdź do strony głównej', 'strefamanagera')}
                  </div>
                </div>
              </a>


              {liveMeetings.length > 1 ? (
                <div onClick={() => {
                  setShowThankYou(false)
                }} className={'primaryBtn'}>
                  <div className="btn btn-lg">
                  {__('Zobacz bezpłatne wydarzenia', 'strefamanagera')}
                  </div>
                </div>
              ) : null}

            </div>

          </li>
        </ul>

      </div>

    </Container>
  )
}